module.exports = __webpack_public_path__ + "static/media/clublea_logo.0a46c877.png";